export default "__VITE_ASSET__BRsEhtyJ__"